module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terri Brisbin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("When "), _c('B', [_c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author Terri Brisbin")], 1), _vm._v(" is not being a glamorous romance author or in a deadline-writing-binge-o'-mania, she's a wife, mom, GRANDMOM and dental hygienist in the southern New Jersey area. A three-time RWA RITA® finalist,"), _c('B', [_vm._v(" Terri ")]), _vm._v("has had more than 50 historical and paranormal romance novels, novellas and short stories published since 1998. You can visit her website:www.terribrisbin.com to learn more about her.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18tV4VG/tc-custom/9781459238398.jpg?1699734110408",
      "alt": "This image is the cover for the book Highlander's Stolen Touch, The MacLerie Clan"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Highlander's Stolen Touch, The MacLerie Clan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("USA Today–")]), _vm._v("bestselling author, a Highland warrior is assigned to escort the woman he loves to her arranged marriage in this medieval romance.")]), _c('br'), _c('br'), _vm._v("Ciara Robertson has loved formidable Highlander Tavis MacLerie all her life. She watched, brokenhearted, while he married and lost another. Now, finally of marriageable age, Ciara throws her heart at his feet. . . . Tavis knows that innocent Ciara thinks she’s in love with him—but she deserves better. Painful experience has proved that he’s a far better warrior than husband, and he’s determined never to marry again. Her dreams shattered, Ciara accepts another man’s hand. Ordered to take Ciara to her husband-to-be, Tavis is tormented—and tempted—every step of the way. . . . "), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0